export default __webpack_public_path__ + "images/avax_033b12.svg";